const CommunicationModel = Backbone.Model.extend({
  defaults: {
    "errorMessage": "",
    "communicationID": 0,
    "communicationTypeID": 0,
    "communicationPrefix": "",
    "communicationDesc": "",
    "isActive": false,
    "isDisplay" : false
  }
});

export default CommunicationModel;
